module.exports = __webpack_public_path__ + "static/media/cv.2392d7d9.svg";